import { render, staticRenderFns } from "./CreateRemitent.vue?vue&type=template&id=7a6c83a4&"
import script from "./CreateRemitent.vue?vue&type=script&lang=js&"
export * from "./CreateRemitent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports